import { useEffect, useState } from 'react';

import { getDisplayError } from '../../../utils/get-display-error';
import { PdfPreview, IPdfPreviewProps } from '../../../components/pdf';
import { SpinnerBlock } from '../../../components/Spinner';
import { Button } from '../../../components/button/Button';
import { constructDownloadUrl } from '../models';
import { ErrorState } from '../../../components/error-state/ErrorState';

export interface IDocumentPreviewProps {
  document: { id: string; hash: string; name: string };
  rotations?: IPdfPreviewProps['rotations'];
  onRotate?: IPdfPreviewProps['onRotate'];
}

export const DocumentPreview: React.FC<IDocumentPreviewProps> = (props) => {
  const { document, rotations, onRotate } = props;
  const [error, setError] = useState<string | null>(null);
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetch = async () => {
      setUrl(constructDownloadUrl({ documentId: document.id, documentHash: document.hash }));
    };

    fetch().catch((err) => setError(getDisplayError(err)));
  }, [document.hash, document.id]);

  if (url) {
    if (document.name.endsWith('.pdf')) {
      return <PdfPreview file={url} filename={document.name} rotations={rotations} onRotate={onRotate} />;
    } else {
      return (
        <div className="border border-border w-full h-full flex flex-col gap-4 justify-center items-center">
          <div className="text-sm font-medium">Preview niet ondersteund voor {document.name}</div>
          <div>
            <Button
              onTrigger={() => {
                // eslint-disable-next-line no-restricted-globals
                window.open(url, '_blank');
              }}
            >
              Download bestand
            </Button>
          </div>
        </div>
      );
    }
  }

  if (error) {
    return <ErrorState error={error} title="Preview laden mislukt" description={error} variant="section" />;
  }

  return <SpinnerBlock message="Loading preview..." />;
};
